import React, { useState } from 'react';
import { X, Save } from 'lucide-react';
import { createTeam, updateTeam } from '../../store/slices/teamSlice';
import { useAppDispatch } from '../../hooks/hooks';
import Inputs from '../../components/inputs';

interface TeamFormProps {
  team?: any;
  onClose: () => void;
}

const TeamForm: React.FC<TeamFormProps> = ({ team, onClose }) => {
  const dispatch = useAppDispatch();
  const [formData, setFormData] = useState({
    name: team?.name || ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.name.trim()) {
      alert('Team name is required');
      return;
    }

    setIsSubmitting(true);

    try {
      if (team) {
        await dispatch(updateTeam({ ...formData, _id: team._id }));
      } else {
        await dispatch(createTeam(formData));
      }
      onClose();
    } catch (error) {
      console.error('Error saving team:', error);
      alert('Error saving team. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="team-form">
        <div className="form-body">
          <Inputs
            label="Team Name"
            name="name"
            type="text"
            value={formData.name}
            onChange={handleInputChange}
            placeholder="Enter team name"
            className="form-control"
            autoComplete="off"
            isRequired={true}
            options={[]}
            id="teamName"
          />
        </div>

        <div className="form-footer">
          <button
            type="button"
            className="btn-secondary"
            onClick={onClose}
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn-primary"
            disabled={isSubmitting || !formData.name.trim()}
          >
            <Save size={16} />
            {isSubmitting ? 'Saving...' : team ? 'Update Team' : 'Create Team'}
          </button>
        </div>
      </form>
  );
};

export default TeamForm;